var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1725,
    cy: 14.1725,
    r: 13.6725,
    fill: "url(#paint0_linear_2504_4349)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4982 19.023V17.9732C18.4982 17.4163 18.2769 16.8823 17.8832 16.4885C17.4894 16.0947 16.9554 15.8735 16.3985 15.8735H12.1992C11.6424 15.8735 11.1083 16.0947 10.7146 16.4885C10.3208 16.8823 10.0996 17.4163 10.0996 17.9732V19.023",
    stroke: "white",
    strokeWidth: 1.57473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2986 13.774C15.4582 13.774 16.3982 12.8339 16.3982 11.6743C16.3982 10.5147 15.4582 9.57471 14.2986 9.57471C13.139 9.57471 12.199 10.5147 12.199 11.6743C12.199 12.8339 13.139 13.774 14.2986 13.774Z",
    stroke: "white",
    strokeWidth: 1.57473,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2504_4349",
    x1: 1.10847,
    y1: 1.60013,
    x2: 40.5553,
    y2: 7.31152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageprofile);
export default __webpack_public_path__ + "static/media/messageprofile.1137b6c337c952984489918be7029aae.svg";
export { ForwardRef as ReactComponent };